import api from "@/api/axiosConfig.js";
import { handleSuccessResponse, handleErrorResponse } from '@/api/apiUtils.js';

const MODULE_NAME = 'EhealthAPI';

export const ehealthAPI = {
  get: async (showNotification = false) => {
    try {
      const response = await api.get('/ehealth/monitor');
      return handleSuccessResponse(response, MODULE_NAME, 'Получение настроек мониторинга', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получении настроек мониторинга', showNotification);
    }
  },

  update: async (payload, showNotification = true) => {
    try {
      const response = await api.put('/ehealth/monitor', payload);
      return handleSuccessResponse(response, MODULE_NAME, 'Сохранение настроек', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'сохранении настроек', showNotification);
    }
  },

  checkNow: async (showNotification = false) => {
    try {
      const response = await api.post('/ehealth/monitor/check');
      return handleSuccessResponse(response, MODULE_NAME, 'Проверка талонов', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'проверке талонов', showNotification);
    }
  },

  relogin: async (showNotification = true) => {
    try {
      const response = await api.post('/ehealth/monitor/relogin');
      return handleSuccessResponse(response, MODULE_NAME, 'Получение нового токена', showNotification);
    } catch (error) {
      return handleErrorResponse(error, MODULE_NAME, 'получении нового токена', showNotification);
    }
  },
};
